import { render, staticRenderFns } from "./subscription-confirm.vue?vue&type=template&id=54083c64&scoped=true&"
import script from "./subscription-confirm.vue?vue&type=script&lang=js&"
export * from "./subscription-confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54083c64",
  null
  
)

export default component.exports